export default __webpack_public_path__ + "08297f47399208aa1eb3790bc8e81ee2.jpg";